import CreatorCollectionPage from './CreatorCollectionPage';

export default CreatorCollectionPage;